import {
  Component,
  ChangeDetectionStrategy,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';

import {
  FormattedKaraokePlayer,
  IFormattedKaraokePlayer,
  IKaraokePlayer,
  KaraokeDTO,
  KaraokePlayer,
} from '@models/grade-unit/karaoke';
import { INavigation } from '@models/navigation';

@Component({
  selector: 'app-karaoke-step-presentation',
  templateUrl: './karaoke-step-presentation.component.html',
  styleUrls: ['./karaoke-step-presentation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KaraokeStepPresentationComponent {
  @Input() public form: UntypedFormGroup = new UntypedFormGroup({});
  @Input() public formatAllForm: UntypedFormGroup = new UntypedFormGroup({});
  @Input()
  public formattedKaraokePlayer: IFormattedKaraokePlayer = new FormattedKaraokePlayer();
  @Input() public karaokePlayer: IKaraokePlayer = new KaraokePlayer();
  @Input() public transcriptWordList: UntypedFormArray = new UntypedFormArray(
    [],
  );
  @Input() public block: KaraokeDTO = new KaraokeDTO();

  @Output() public emitResetTranscript = new EventEmitter<void>();

  public formattingCheckboxList: INavigation[] = [
    {
      id: 0,
      label: 'Bold',
      link: 'isBold',
    },
    {
      id: 1,
      label: 'Italic',
      link: 'isItalicized',
    },
    {
      id: 2,
      label: 'New line',
      link: 'hasNewline',
    },
    {
      id: 3,
      label: 'Header',
      link: 'hasHeader',
    },
    {
      id: 4,
      label: 'Blue',
      link: 'isBlue',
    },
    {
      id: 5,
      label: 'Highlight',
      link: 'isHighlighted',
    },
  ];

  public closeFormattingMenu(): void {
    // noop
  }

  public resetTranscript(): void {
    this.emitResetTranscript.emit();
  }
}
